/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Not_Used_Since_TrackingInputs */

const en_admin_user_detail_not_used_since_tracking = /** @type {(inputs: Admin_User_Detail_Not_Used_Since_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not used since activity tracking was introduced`)
};

const de_admin_user_detail_not_used_since_tracking = /** @type {(inputs: Admin_User_Detail_Not_Used_Since_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit Einführung der Erfassung nicht genutzt`)
};

/**
* | output |
* | --- |
* | "Not used since activity tracking was introduced" |
*
* @param {Admin_User_Detail_Not_Used_Since_TrackingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_not_used_since_tracking = /** @type {((inputs?: Admin_User_Detail_Not_Used_Since_TrackingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Not_Used_Since_TrackingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_not_used_since_tracking(inputs)
	return en_admin_user_detail_not_used_since_tracking(inputs)
});